import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import StoryListPage from './components/StoryListPage';
import StoryDetails from './components/StoryDetails';
import TopBar from './components/TopBar';
import { localStorageOrDefault } from './components/util'

import './App.css';
import './index.css';


function App() {


  const [offlineMode, setOfflineMode] = useState(
    JSON.parse(localStorageOrDefault('offlineMode', false))
  );
  const [numStories, setNumStories] = useState(
    JSON.parse(localStorageOrDefault('numStories', 10))
  );
  const [staleAfterMins, setStaleAfterMins] = useState(
    JSON.parse(localStorageOrDefault('staleAfterMins', 15))
  );

  return (
    <div className="App">
      <Router>
        <TopBar 
          offlineMode={offlineMode} setOfflineMode={setOfflineMode} 
          numStories={numStories} setNumStories={setNumStories} 
          staleAfterMins={staleAfterMins} setStaleAfterMins={setStaleAfterMins} 
        />
          <Routes>
            <Route
              path="/"
              element={ <StoryListPage offlineMode={offlineMode} numStories={numStories} staleAfterMins={staleAfterMins}></StoryListPage> }
            />
            <Route 
              path="/story/:id" 
              element={<StoryDetails offlineMode={offlineMode} > </StoryDetails>} 
            />
          </Routes>
      </Router>
    </div>
  );
}

export default App;
